import { useEffect, useState } from 'react';
import clickDown from '../assets/click_down.m4a';
import clickUp from '../assets/click_up.m4a';
import { darkenHSL } from '../util.js';
import './circle_button.css';

const soundDown = new Audio(clickDown);
const soundUp = new Audio(clickUp);

const CircleButton = ({ size, bgColor, imageContent, onMouseDown, onMouseUp }) => {

    const [borderColor, setBorderColor] = useState(darkenHSL(bgColor, 0.4));

    useEffect(() => {
        setBorderColor(darkenHSL(bgColor, 0.4))
    }, [bgColor])
    
    function handleMouseDown() {
        soundDown.play();
        if (onMouseDown) {
            onMouseDown();
        }
    };

    function handleMouseUp() {
        soundUp.play();
        if (onMouseUp) {
            onMouseUp();
        }
    }
  
    return (
        <div className={"circle"}
            style={{
                height: size,
                width: size,
                backgroundColor: bgColor,
                border: `2px solid ${borderColor}`,
            }} 
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}>
        {imageContent &&
            <img src={imageContent} alt="Circle content" />}
      </div>
    );
};

export default CircleButton;